import { useQuery } from '@tanstack/react-query'

import { ReactQueryHttpError, VqaConfiguration } from '@sparkai/shared-types'

import { apiClient } from '../../apiClient'

const VQA_CONFIGURATION_QUERY_PREFIX = 'vqa-configuration'

function useGetConfigurationForProgramId(programId?: string) {
  return useQuery<VqaConfiguration, ReactQueryHttpError>({
    queryKey: [VQA_CONFIGURATION_QUERY_PREFIX, programId],
    queryFn: async () => {
      const { data } = await apiClient.get<VqaConfiguration>(
        `/int/v3/programs/${programId}/insights/vqa/configuration`
      )
      return data
    },
    enabled: Boolean(programId),
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export { useGetConfigurationForProgramId }
